module.exports = "/_next/static/images/EngineeringCardImage-6677cdd0e3da36b6861abe9cc5ce3fda.webp";